import AddressDisplay from './AddressDisplay';

export default AddressDisplay;
